import { basUrl, reqGet, reqPost } from './index'

//获取药物名称
export const getMenuList = () => { return reqGet(basUrl + "isi/web/column/tree/10") }
//获取分类列表
export const getArticleList = (params) => { return reqPost(basUrl + "public/article/list", params) }
//获取文章详情
export const getArticleDetail = (params) => { return reqGet(basUrl + "public/" + params) }
//获取搜索内容
export const getSearchList = (params) => { return reqPost(basUrl + "public/search/list", params) }
//三级分类列表
export const getThreeList = (params) => { return reqPost(basUrl + "public/article/classifyList", params) }
//三级分类列表
export const getThreeArticleList = (params) => { return reqPost(basUrl + "isi/web/article/list", params) }
//公益项目列表
export const getPubList = (params) => { return reqGet(basUrl + "public/welfare/project/article", params) }

//搜索历史过期项目
export const getHistoryList = (params) => { return reqPost(basUrl + "public/search/expired/list", params) }



// WEBPACK FOOTER //
// ./src/api/api.js